import * as settings from "../../../services/settings";
import * as warehouseService from "../../../services/warehouse";

import { Breadcrumb, Button, Checkbox, Col, Form, Input, Row, Space, Spin, Typography, notification } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAccessToken } from "../../../contexts/AccessTokenContext";
import { useTranslation } from "react-i18next";

const TYPE_EDIT = "EDIT";
const TYPE_CREATE = "CREATE";

export const CreateWarehousePage = () => {
  const { accessToken } = useAccessToken();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { Title } = Typography;
  const { t } = useTranslation("warehouse", "buttons", "common");
  const [warehouse, setWarehouse] = useState({});
  const [stateType, setStateType] = useState(TYPE_CREATE);
  const { TextArea } = Input;
  const navigation = useNavigate();
  const location = useLocation();
  const state = location.state;

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const onFinish = async (values) => {
    await form.validateFields();
    // const { is_origin, is_active, is_destination } = values
    // if (is_origin) {
    //   values['is_destination'] = !is_origin
    // }

    // if (is_origin == undefined) {
    //   values['is_origin'] = false
    //   values['is_destination'] = true
    // }

    // if (is_active == undefined) {
    //   values['is_active'] = false
    // } else {
    //   values['is_active'] = is_active
    // }

    if (stateType == TYPE_CREATE) {
      createWarehouse(values);
    } else {
      updateWarehouse(values);
    }
  };

  const updateWarehouse = async (value) => {
    const { id } = warehouse;
    value.id = id;

    try {
      const response = await warehouseService.updateWarehouse(accessToken, value);
      if (response == undefined) {
        openNotificationWithIcon(
          settings.NotificationType.ERROR,
          <>{"Fail."}</>,
          <>{"Update warehouse is error, Please check service"}</>
        );
        return;
      } else {
        openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Update Success"}</>);

        setTimeout(() => {
          navigation("/warehouses");
        }, 2000);
      }
    } catch (err) {
      console.error("[CreateWarehousePage] updateWarehouse: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const validateCode = async (_, value) => {
    if (value && value.trim().length < 2) {
      return Promise.reject(new Error("The code must be at least 2 characters long!"));
      // return Promise.reject(
      //   new Error('The code must be at least 2 characters long!'),
      // )
    }
    return Promise.resolve();
  };

  const validateName = (_, value) => {
    if (value && value.length <= 99) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("The input must be at least 99 characters long!"));
  };

  const createWarehouse = async (values) => {
    setLoading(true);
    try {
      const response = await warehouseService.createWarehouse(accessToken, values);

      if (response !== null || response != undefined) {
        openNotificationWithIcon(
          settings.NotificationType.SUCCESS,
          <>{"Success."}</>,
          <>{"Create Warehouse success"}</>
        );

        setTimeout(() => {
          navigation("/warehouses");
        }, 2000);
      }
    } catch (err) {
      console.error("[CreateWarehousePage] createWarehouse: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }

    setLoading(false);
  };

  const items = [
    {
      title: <span>{t("Page_Body_Tab_Menu.Home", { ns: "menus" })}</span>,
    },
    {
      title: <span>{t("Page_Body_Tab_Menu.Menu", { ns: "menus" })}</span>,
    },
    {
      title: <a href="/warehouses">{t("Title_Warehouse")}</a>,
    },
    {
      title: (
        <a
          onClick={() => {
            console.log("state", stateType);
          }}
          style={{ fontWeight: 600, color: "black" }}
        >
          {stateType == TYPE_EDIT
            ? `${t("Create_Warehouse.Title_Edit_Warehouse")}`
            : `${t("Create_Warehouse.Title_Add_Warehouse")}`}
        </a>
      ),
    },
  ];

  useEffect(() => {
    setLoading(true);
    if (!accessToken) return;
    setLoading(false);
    if (state.type == TYPE_EDIT) {
      setStateType(TYPE_EDIT);
      setWarehouse(state.value);
      form.setFieldsValue({
        warehouse_code: state.value.warehouse_code,
        warehouse_name: state.value.warehouse_name,
        warehouse_address: state.value.warehouse_address,
        is_origin: state.value.is_origin,
        is_destination: state.value.is_destination,
        is_active: state.value.is_active,
      });
    }
  }, [accessToken, warehouse, state, form]);

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row style={{ overflowX: "auto" }}>
          <Col span={24}>
            <Breadcrumb items={items}></Breadcrumb>
            <Title level={2} style={{ marginTop: "3%" }}>
              {stateType == TYPE_EDIT
                ? `${t("Create_Warehouse.Title_Edit_Warehouse")}`
                : `${t("Create_Warehouse.Title_Add_Warehouse")}`}
            </Title>
            <Form
              form={form}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              style={{ maxWidth: 600, minWidth: 360, marginTop: "3%" }}
              onFinish={onFinish}
            >
              <Form.Item
                form={form}
                label={t("Create_Warehouse.Input_Warehouse_Code")}
                name="warehouse_code"
                key="warehouse_code"
                rules={[
                  { required: true, whitespace: true, message: "Please input code!" },
                  { min: 1 },
                  { validator: validateCode },
                ]}
              >
                <Input style={{ minWidth: 200 }} />
              </Form.Item>
              <Form.Item
                label={t("Create_Warehouse.Input_Warehouse_Name")}
                name="warehouse_name"
                rules={[{ required: true, message: "Please input name!" }, { validator: validateName }]}
              >
                <Input maxLength={99} style={{ minWidth: 200 }} />
              </Form.Item>
              <Form.Item label={t("Create_Warehouse.Input_Warehouse_Address")} name="warehouse_address">
                <TextArea rows={4} style={{ minWidth: 200 }} />
              </Form.Item>
              <Form.Item label={t("Create_Warehouse.Input_Is_Origin")} name="is_origin" valuePropName="checked">
                <Checkbox
                  onChange={(e) => {
                    if (e.target.checked) {
                      form.setFieldsValue({ is_destination: false });
                    }
                  }}
                >
                  {t("Create_Warehouse.Input_Is_Origin_Detail")}
                </Checkbox>
              </Form.Item>
              <Form.Item
                label={t("Create_Warehouse.Input_Is_Destination")}
                name="is_destination"
                valuePropName="checked"
              >
                <Checkbox
                  onChange={(e) => {
                    if (e.target.checked) {
                      form.setFieldsValue({ is_origin: false });
                    }
                  }}
                >
                  {t("Create_Warehouse.Input_Is_Destination_Detail")}
                </Checkbox>
              </Form.Item>
              <Form.Item label={t("Create_Warehouse.Input_Status")} name="is_active" valuePropName="checked">
                <Checkbox>{t("Create_Warehouse.Input_Status_Detail")}</Checkbox>
              </Form.Item>
              <Row align="middle" justify="end" style={{ marginTop: "20px" }}>
                <Form.Item>
                  <Space>
                    <Button type="primary" htmlType="submit">
                      {t("BTN_Save", { ns: "buttons" })}
                    </Button>
                    <Button
                      htmlType="button"
                      onClick={() => {
                        navigation("/warehouses");
                      }}
                    >
                      {t("BTN_Cancel", { ns: "buttons" })}
                    </Button>
                  </Space>
                </Form.Item>
              </Row>
            </Form>
          </Col>
        </Row>
      </Spin>
    </>
  );
};
